// eslint-disable-next-line import/prefer-default-export
export const ReportType = {
  MONTHLY: 'MONTHLY',
  PARTIAL: 'PARTIAL'
};
